export function siblingPath(path, name) {
    return path.substring(0, path.lastIndexOf("/") + 1) + name
}
